import angular from "angular";
import { machineManufacturerLookupConfig } from "./machineManufacturer";
import { machineCabinetTypeLookupConfig } from "./machineCabinetType";
import { machineSlotTypeLookupConfig } from "./machineSlotType";
import { moduleName as recordsModuleName } from "../../../../records";
import { machineDenominationLookupConfig } from "./denomination";
import { machineThemeLookupConfig } from "./theme";
import { machineDisplayTypeLookupConfig } from "./machineDisplayType";
import { machineGameNameLookupConfig } from "./machineGameName";
import { machineGameFamilyLookupConfig } from "./machineGameFamily";
import { machineGameTypeLookupConfig } from "./machineGameType";
import { machineLeaseCategoryLookupConfig } from "./machineLeaseCategory";
import { machineModelNumberLookupConfig } from "./machineModelNumber";
import { machinePlayerTrackingTypeLookupConfig } from "./machinePlayerTrackingType";
import { machineProgressiveTypeLookupConfig } from "./machineProgressiveType";
import { machineConversionTypeLookupConfig } from "./machineConversionType";
import { machineDecommissionTypeLookupConfig } from "./machineDecommissionType";
import { machineWarehouseTypeLookupConfig } from "./machineWarehouseType";
import { bankTypeLookupConfig } from "./bankType";
import { complianceFlagLookupConfig } from "./complianceFlag";
import { featureOptionsLookupConfig } from "./featureOptions";
import { machineLeasedLookupConfig } from "./machineLeased";
import { machineEpromConfigurationLabel } from "./machineEpromConfigurationLabel";

export const vsModuleName = "SlotTrak.Machines.Config.Lookups";

angular
  .module(vsModuleName, [recordsModuleName])
  .config(machineDenominationLookupConfig)
  .config(machineManufacturerLookupConfig)
  .config(machineCabinetTypeLookupConfig)
  .config(machineSlotTypeLookupConfig)
  .config(machineThemeLookupConfig)
  .config(machineDisplayTypeLookupConfig)
  .config(machineGameNameLookupConfig)
  .config(machineGameFamilyLookupConfig)
  .config(machineGameTypeLookupConfig)
  .config(machineLeaseCategoryLookupConfig)
  .config(machineModelNumberLookupConfig)
  .config(machinePlayerTrackingTypeLookupConfig)
  .config(machineProgressiveTypeLookupConfig)
  .config(machineThemeLookupConfig)
  .config(machineConversionTypeLookupConfig)
  .config(machineDecommissionTypeLookupConfig)
  .config(machineWarehouseTypeLookupConfig)
  .config(bankTypeLookupConfig)
  .config(complianceFlagLookupConfig)
  .config(featureOptionsLookupConfig)
  .config(machineLeasedLookupConfig)
  .config(machineEpromConfigurationLabel);

/* TODO - add client specific machine lookups here */
